// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".remove-formula-padrao {\n  font-size: 28px;\n  color: #b75a5a;\n}\n\n.manipulacao-button {\n  margin-left: 3px;\n  color: #fff !important;\n}\n.manipulacao-button:hover {\n  opacity: 0.8;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
